import React from "react";
import tourevents1 from "./images/tourevents1.jpg";
import tourevents2 from "./images/tourevents2.jpg";
import tourevents3 from "./images/tourevents3.jpg";

export default function () {
  return (
    <div>
      <section id="tour-events-2" className=" mx-auto container row mt-5 mb-5">
        <h2 className="mb-5 mt-5">Tour Events for You</h2>
        <div className="col-lg-4 col-sm-6 col-12">
          <div className="card border-0 ">
            <img src={tourevents1} className="card-img-top" alt="..." />
            <div className="card-body d-flex justify-content-between">
              <h5 className="card-title">
                <a href="/">Kerala River View Tour</a>
              </h5>
              <p className="card-text">
                <i className="fa-regular fa-bookmark" />
              </p>
            </div>
            <span className="container"> 12 Places | 3 Activities </span>
            <hr />
            <div className="card-body">
              <ul className="list-unstyled d-flex gap-3">
                <li>
                  <i className="fa-solid fa-clock mx-1" />
                  <span>3 Days 4 Nights</span>
                </li>
                <li>
                  <i className="fa-solid fa-user mx-1" />
                  <span>Capacity 20</span>
                </li>
              </ul>
              <ul className="list-unstyled d-flex justify-content-between ">
                <li>
                  <h4>
                    $895.50
                    <span className="fs-6 text-decoration-line-through text-danger ">
                      $4500
                    </span>
                  </h4>
                </li>
                <li>
                  {" "}
                  <button className="btn btn-success">Book Now</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-4  col-6 disable">
          <div className="card border-0 ">
            <img src={tourevents2} className="card-img-top" alt="..." />
            <div className="card-body d-flex justify-content-between">
              <h5 className="card-title">
                <a href="/">Mountain Hikking Tour</a>
              </h5>
              <p className="card-text">
                <i className="fa-regular fa-bookmark" />
              </p>
            </div>
            <span className="container"> 12 Places | 3 Activities </span>
            <hr />
            <div className="card-body">
              <ul className="list-unstyled d-flex gap-3">
                <li>
                  <i className="fa-solid fa-clock mx-1" />
                  <span>3 Days 4 Nights</span>
                </li>
                <li>
                  <i className="fa-solid fa-user mx-1" />
                  <span>Capacity 20</span>
                </li>
              </ul>
              <ul className="list-unstyled d-flex justify-content-between ">
                <li>
                  <h4>
                    $895.50
                    <span className="fs-6 text-decoration-line-through text-danger ">
                      $4500
                    </span>
                  </h4>
                </li>
                <li>
                  {" "}
                  <button className="btn btn-success">Book Now</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md-4 disable ipads-disable">
          <div className="card border-0 ">
            <img src={tourevents3} className="card-img-top" alt="..." />
            <div className="card-body d-flex justify-content-between">
              <h5 className="card-title">
                <a href="/">Sundorbonads Tour 2022</a>
              </h5>
              <p className="card-text">
                <i className="fa-regular fa-bookmark" />
              </p>
            </div>
            <span className="container"> 12 Places | 3 Activities </span>
            <hr />
            <div className="card-body">
              <ul className="list-unstyled d-flex gap-3">
                <li>
                  <i className="fa-solid fa-clock mx-1" />
                  <span>3 Days 4 Nights</span>
                </li>
                <li>
                  <i className="fa-solid fa-user mx-1" />
                  <span>Capacity 20</span>
                </li>
              </ul>
              <ul className="list-unstyled d-flex justify-content-between ">
                <li>
                  <h4>
                    $895.50
                    <span className="fs-6 text-decoration-line-through text-danger ">
                      $4500
                    </span>
                  </h4>
                </li>
                <li>
                  {" "}
                  <button className="btn btn-success">Book Now</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
